import { render, staticRenderFns } from "./CustomerNew.vue?vue&type=template&id=6fde024a"
import script from "./CustomerNew.vue?vue&type=script&lang=ts"
export * from "./CustomerNew.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports